import { gql } from '@apollo/client';

export const DEVICE_MONITOR_FILTER_OPTIONS_GQL = gql`
  query DeviceMonitorPage_GetFilterOptions {
    organization(where: { deleted_at: { _is_null: true } }, order_by: { name: asc }) {
      id
      name
    }
    farm(where: { deleted_at: { _is_null: true } }, order_by: { name: asc }) {
      id
      name
    }
  }
`;

export const DEVICE_MONITOR_DEVICES_GQL = gql`
  query DeviceMonitorPage_GetDevices(
    $limit: Int!
    $offset: Int!
    $where: device_bool_exp!
    $orderBy: [device_order_by!]!
    $deviceUnreachableFaultCode: Int!
  ) {
    device(
      limit: $limit
      offset: $offset
      where: {
        _and: [
          $where
          { hw_version: { _neq: "mock" } }
          {
            device_assignments: {
              feed_line: {
                deleted_at: { _is_null: true }
                farm: { deleted_at: { _is_null: true } }
              }
            }
          }
        ]
      }
      order_by: $orderBy
    ) {
      id
      serial
      device_assignments(
        where: { ended_at: { _is_null: true } }
        order_by: { started_at: desc }
        limit: 1
      ) {
        feed_line {
          id
          name
          farm {
            id
            name
            organization {
              id
              name
            }
          }
        }
      }
      most_recent_transaction: transactions(order_by: { occured_at: desc }, limit: 1) {
        occured_at
      }
      active_device_unreachable_fault: faults(
        where: { ended_at: { _is_null: true }, code: { _eq: $deviceUnreachableFaultCode } }
        limit: 1
      ) {
        id
      }
    }
  }
`;

export const DEVICE_MONITOR_INTERNET_SCORES_GQL = gql`
  query DeviceMonitorPage_GetInternetScores($deviceIds: [uuid!]!, $last24h: bigint!) {
    device(where: { id: { _in: $deviceIds } }) {
      id
      device_data_aggregate(where: { created_at: { _gte: $last24h } }) {
        aggregate {
          count
          sum {
            ended_at
            created_at
            duration
          }
        }
      }
    }
  }
`;

